import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Typography, Alert, Box, CircularProgress } from '@mui/material';
import { AdminPanelSettings } from '@mui/icons-material';
import { superAdminApi } from '../services/superAdminApi';
import { AuthLayout } from '../components/AuthLayout';
import { Brand } from '../components/Brand';

export const SuperAdminLoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await superAdminApi.login(email, password);
      if (response.success && response.data) {
        localStorage.setItem('sa_token', response.data.token);
        navigate('/super-admin/dashboard');
      } else {
        setError(response.message || 'Error al iniciar sesión');
      }
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Box textAlign="center">
        <Brand size="md" subtitle="Super Admin" />
        <AdminPanelSettings sx={{ fontSize: 40, color: 'primary.main', mt: 1 }} />
      </Box>
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
        <TextField fullWidth label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required margin="normal" disabled={loading} />
        <TextField fullWidth label="Contraseña" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required margin="normal" disabled={loading} />
        {error && (<Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>)}
        <Button type="submit" fullWidth variant="contained" disabled={loading} sx={{ mt: 2 }} size="large">
          {loading ? <CircularProgress size={20} /> : 'Entrar'}
        </Button>
      </Box>
    </AuthLayout>
  );
};
